import { NgModule } from "@angular/core";
import { DashboardComponent } from "./dashboard.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { SetbackDialogComponent } from "./components/setback-dialog/setback-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SendMessageDialogComponent } from "./components/send-message-dialog/send-message-dialog.component";
import { RecallDialogComponent } from './components/recall-dialog/recall-dialog.component';
import { MatDialogModule } from "@angular/material/dialog";
import { NgxsModule } from "@ngxs/store";

@NgModule({
  declarations: [
    DashboardComponent,
    SetbackDialogComponent,
    SendMessageDialogComponent,
    RecallDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DashboardRoutingModule,
    ReactiveFormsModule,
    NgxsModule.forFeature([]),
    FormsModule,
    MatDialogModule
  ],
})
export class DashboardModule {}
